import React, { useEffect, useRef, useState } from 'react';
import './report.scss';

import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useSearchParams } from 'react-router';
import fileDownload from 'js-file-download';
import {
  getJsonFromStorage,
  getPaginationOpts, getResponseError,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import { deleteReport, loadReportById, loadReportList } from '../actions';
import { getSystemData } from '../../System/reducer';
import Loader from '../../../components/base/Loader/Loader';
import { getReportData } from '../reducer';
import Pagination from '../../../components/base/Pagination/Pagination';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import { statusFormatter, dateTimeFormatter, userPositionFormatter } from '../../../utils/formatters';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import ReportForm from './ReportForm';
import { loadFileByUrl, showGlobalConfirm } from '../../System/actions';
import getDefaultDataRange from '../../../utils/getDefaultDataRange';
import RangeDatePicker from '../../../components/fields/RangeDatePicker/RangeDatePicker';
import { REPORT_MODULE } from '../../../configs/moduleNames';
import { REPORT_STATUS_NAMES } from '../../../configs';
import ViewFile from '../../System/components/ViewFile';

export default function ReportPage() {
  const blockRef = useRef(null);
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const store = useStore();
  const { updatePeriod } = useSelector(getSystemData);
  const {
    reportListMeta,
    loadingReportList,
    reportList,
    loadingCurrentReport,
    currentReport,
    loadingEditReport,
    loadingDeleteReport,
    loadingCreateReport,
  } = useSelector(getReportData);
  const [isShowForm, setIsShowForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [showFile, setShowFile] = useState(null);

  const filterName = 'report-filter';

  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[REPORT_MODULE].reportListMeta, opts); // костыль внедрен из за потери контекста в updatePeriod. Он сохранял первую функцию
    const requestData = {
      ...paginationOpts,
      filter: getValues(),
    };
    const p1 = dispatch(loadReportList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const defaultDate = getDefaultDataRange();
  const defaultFilterValues = {
    created_at_from: defaultDate[0], created_at_to: defaultDate[1], search: '', created_at: '',
  };
  const {
    getValues, control, setValue, watch, reset,
  } = useForm({
    defaultValues: defaultFilterValues,
    resetOptions: {
      keepValues: false,
      keepDirtyValues: false,
      keepDefaultValues: false,
    },
  });

  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  const handleEdit = item => event => {
    if (!item) {
      return;
    }
    dispatch(loadReportById(item.id))
      .then(() => {
        setIsShowForm(true);
        setIsEdit(true);
      })
      .catch(response => errorNotification('Загрузка записи', getResponseError(response)));

    event.preventDefault();
    event.stopPropagation();
    return false;
  };

  const handleDownload = item => event => {
    if (!item) {
      return;
    }
    dispatch(loadFileByUrl(item?.files[0]?.url))
      .then(data => {
        if (data) {
          fileDownload(data, item?.files[0]?.file_name);
          successNotification('Скачивание файла', 'Успешно');
        }
      })
      .catch(responseLogWithNotification);
    event.preventDefault();
    event.stopPropagation();
    return false;
  };

  const handleView = item => event => {
    if (!item) {
      return;
    }
    setShowFile(item?.files[0]);
    event.preventDefault();
    event.stopPropagation();
    return false;
  };

  const handleCloseViewFile = () => {
    setShowFile(null);
  };

  const handleDelete = item => event => {
    dispatch(showGlobalConfirm({
      confirmMessage: `Удаление отчета "${item.name || ''}"`,
      confirmButtonText: 'Удалить',
      confirmClassName: 'remove-preset',
    })).then(() => {
      dispatch(deleteReport(item.id)).then(() => {
        loadData();
        successNotification('Удаление отчета', 'Удаление прошло успешно');
      }).catch(response => {
        errorNotification('Удаление отчета', getResponseError(response));
      });
    }).catch(() => {});

    event.preventDefault();
    event.stopPropagation();
    return false;
  };

  const handleClose = () => {
    setIsShowForm(false);
    setIsEdit(false);
  };

  const columns = [
    {
      dataField: 'name',
      text: 'Наименование отчета',
      disableSort: true,
    },
    {
      dataField: 'from_date',
      text: 'Дата начала периода',
      formatter: dateTimeFormatter,
      disableSort: true,
    },
    {
      dataField: 'to_date',
      text: 'Дата окончания периода',
      formatter: dateTimeFormatter,
      disableSort: true,
    },
    {
      dataField: 'created_at',
      text: 'Дата создания',
      formatter: dateTimeFormatter,
      disableSort: true,
    },
    {
      dataField: 'status',
      text: 'Статус',
      disableSort: true,
      formatter: a => statusFormatter(a, 'report.status', REPORT_STATUS_NAMES),
    },
    {
      dataField: 'creator',
      text: 'Автор',
      headerClassName: 'user-column',
      formatter: userPositionFormatter,
      disableSort: true,
    },

  ];

  const moreFormatter = (_, item) => (
    <TooltipWithPortal
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="more-actions"
      tooltipContent={(
        <div className="more-wrapper">
          <Button disabled={item.status !== 3} variant="link" className="w-100 more-button" onClick={handleView(item)}>
            Просмотреть
          </Button>
          <Button disabled={item.status !== 3} variant="link" className="w-100 more-button" onClick={handleDownload(item)}>
            Скачать
          </Button>
          {/* <Button variant="link" className="w-100 more-button" onClick={handleEdit(item)}> */}
          {/*  Редактировать */}
          {/* </Button> */}
          <Button variant="link" className="w-100 more-button" onClick={handleDelete(item)}>
            Удалить
          </Button>
        </div>
      )}
      classNameWrapper="more-tooltip-wrapper"
      className="more-tooltip"
    />
  );

  return (
    <div className="page application-page">
      <Loader global loading={loadingReportList || loadingCurrentReport || loadingEditReport || loadingDeleteReport || loadingCreateReport} />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.report.list' })}</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={RangeDatePicker}
            dtoObject={{
              name: 'created_at_from',
              type: String,
              labelKey: 'created_at',
            }}
            hideSmallButtons
            showArrowIcon
            usePortal
            placeholder="Дата"
            changeFormat="YYYY-MM-DD"
            inputProps={{
              value: [getValues('created_at_from'), getValues('created_at_to')],
              onChange: e => {
                const v = e.target.value;
                setValue('created_at_from', v[0]);
                setValue('created_at_to', v[1]);
              },
            }}
            className="no-border"
          />
          <div className="filter-sep" />
          {/* <FieldDTO */}
          {/*  control={control} */}
          {/*  component={TextInput} */}
          {/*  dtoObject={{ */}
          {/*    name: 'search', */}
          {/*    type: String, */}
          {/*    labelKey: 'search', */}
          {/*  }} */}
          {/*  className="no-border" */}
          {/*  inputBefore={( */}
          {/*    <div className="search-wrapper"> */}
          {/*      <Icons customIcon className="search" width={24} height={24} icon="search" /> */}
          {/*    </div> */}
          {/*  )} */}
          {/* /> */}
          {/* <FieldDTO */}
          {/*  control={control} */}
          {/*  component={CustomSelectInput} */}
          {/*  dtoObject={{ */}
          {/*    name: 'status', */}
          {/*    type: String, */}
          {/*    labelKey: 'status', */}
          {/*  }} */}
          {/*  className="no-border" */}
          {/* /> */}
          {/* <FieldDTO */}
          {/*  control={control} */}
          {/*  component={DateTimePicker} */}
          {/*  dtoObject={{ */}
          {/*    name: 'created_at', */}
          {/*    type: String, */}
          {/*    labelKey: 'created_at', */}
          {/*  }} */}
          {/*  hideSmallButtons */}
          {/*  showArrowIcon */}
          {/*  usePortal */}
          {/*  className="no-border" */}
          {/* /> */}
          {/* <div className="filter-sep" /> */}
          <Button variant="second" className="" onClick={() => { setIsShowForm(true); setIsEdit(false); }}>
            <Icons
              customIcon
              className="file-download"
              width={24}
              height={24}
              icon="plus"
            />
          </Button>
        </FilterRow>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content" ref={blockRef}>
          <div className="grid-wrapper frame">
            <div className="custom-scroll-theme sticky-table-wrapper">
              <CustomizedGrid
                data={reportList}
                columns={columns}
                name="report-list"
                settingsFormatter={moreFormatter}
              />
            </div>
          </div>
          <Pagination meta={reportListMeta} list={reportList} handleChangeMeta={loadData} />
        </div>
      </div>
      {isShowForm ? <ReportForm key={currentReport && currentReport.id} isEdit={isEdit} current={currentReport} loadData={loadData} close={handleClose} /> : null}
      {showFile ? <ViewFile file={showFile} handleClose={handleCloseViewFile} title="Просмотр отчета" /> : null}
    </div>
  );
}
